import React from "react";
import UserIcon from "../../Icon-SVG/UserIcon";
import LogoutIcon from "../../Icon-SVG/LogoutIcon";
import { Link } from "react-router-dom";
import ArrowBottomIcon from "../../Icon-SVG/ArrowBottomIcon";
import ArrowTopIcon from "../../Icon-SVG/ArrowTopIcon";
import packageJson from "../../../../package.json";
import "./styles.scss";

const Menu = ({ show, setShow, username }) => {
  const logoutHandler = (e) => {
    e.stopPropagation();
    setShow(true);
  };
  return (
    <>
      {show ? (
        <>
          <ArrowTopIcon width={21} height={8} margin="0 5px" />
          <div className="header__menu">
            <div className="header__menu__first-row">
              <p>Welcome {username}</p>
              <span>v{packageJson.version}</span>
            </div>
            <Link to="/user-profile" className="header__menu-button">
              <UserIcon width={12} height={12} />
              <span>Profile</span>
            </Link>
            <button className="header__menu-button" onClick={logoutHandler}>
              <LogoutIcon width={12} height={12} />
              <span>Logout</span>
            </button>
          </div>
        </>
      ) : (
        <ArrowBottomIcon width={21} height={9} margin="0 5px" />
      )}
    </>
  );
};

export default Menu;
